import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { CodeSystemDTO } from "../types/codeSystemDTO";
import apiClient from "../main/apiClient";

const useFetchCodeSystem = (organisationId: string, codeSystemName: string) => {
    return useQuery<CodeSystemDTO, AxiosError>({
        queryKey: ["codeSystem"],
        queryFn: () =>
          apiClient.get(`/organisation/${organisationId}/codesystem?codeSystemName=${codeSystemName}`).then((resp) => resp.data),
    });
}

export { useFetchCodeSystem }